/* tslint:disable */
/* eslint-disable */
/**
 * external-information-requests
 * Medicaid Pending document requests to family members, with the staff workspace and the family portal
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const OutreachStatus = {
    Pending: 'pending',
    Sending: 'sending',
    Accepted: 'accepted',
    Failed: 'failed',
    Unknown: 'unknown',
    Cancelled: 'cancelled',
} as const;
export type OutreachStatus = typeof OutreachStatus[keyof typeof OutreachStatus];


export function instanceOfOutreachStatus(value: any): boolean {
    for (const key in OutreachStatus) {
        if (Object.prototype.hasOwnProperty.call(OutreachStatus, key)) {
            if (OutreachStatus[key as keyof typeof OutreachStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function OutreachStatusFromJSON(json: any): OutreachStatus {
    return OutreachStatusFromJSONTyped(json, false);
}

export function OutreachStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutreachStatus {
    return json as OutreachStatus;
}

export function OutreachStatusToJSON(value?: OutreachStatus | null): any {
    return value as any;
}

export function OutreachStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): OutreachStatus {
    return value as OutreachStatus;
}

